<template>
  <div class="main2-content">
    <div class="panel-content">
      <!-- start 0 -->
      <div
        class="model-title"
        :class="{ active: layoutShow(0) }"
        @click="handleIndex(0)"
      >
        <div class="model-line">
          {{ btn[0].subtitle }}<br />{{ btn[0].subtitleEn }}
        </div>
        <div class="model-icon-left">
          <i :class="iconShow(0)"></i>
        </div>
      </div>
      <div class="layout-flex" v-if="layoutShow(0)">
        <div class="layout-flex-2">
          <img :src="require('../../assets/csr/imgsMobile/MAtu1@2x.png')" style="width: 100%" />
        </div>
        <div class="layout-flex-1">
          <div class="flex-head">
            <div class="dec" v-html="btn[this.btnIndex].dec"></div>
            <div class="decEn" v-html="btn[this.btnIndex].decEn"></div>
          </div>
          <div class="flex-model">
            <div class="flex-model-title">
              {{ btn[this.btnIndex].subtitle2 }}<br />{{ btn[this.btnIndex].subtitleEn2 }}
            </div>
            <div class="flex-model-line"></div>
            <div class="flex-model-dec">
              <div class="dec">
                <div v-html="btn[this.btnIndex].dec2"></div>
              </div>
              <div class="decEn">
                <div v-html="btn[this.btnIndex].decEn2"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="layout-flex-1">
          <div
            class="flex-model"
            v-for="(item, index) in btn[this.btnIndex].list"
            :key="index"
          >
            <div class="flex-model-title">
              {{ item.title }}<br />{{ item.titleEn }}
            </div>
            <div class="flex-model-line"></div>
            <div class="flex-model-dec">
              <div class="dec"><div v-html="item.dec"></div></div>
              <div class="decEn">
                <div v-html="item.decEn"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
	<div class="panel-content">
	  <!-- start 0 -->
	  <div
	    class="model-title"
	    :class="{ active: layoutShow(1) }"
	    @click="handleIndex(1)"
	  >
	    <div class="model-line">
	      {{ btn[1].subtitle }}<br />{{ btn[1].subtitleEn }}
	    </div>
	    <div class="model-icon-left">
	      <i :class="iconShow(1)"></i>
	    </div>
	  </div>
	  <div class="layout-flex" v-if="layoutShow(1)">
	    <div class="layout-flex-2">
	      <img :src="require('../../assets/csr/imgsMobile/MAtu1@2x.png')" style="width: 100%" />
	    </div>
	    <div class="layout-flex-1">
	      <div class="flex-head">
	        <div class="dec" v-html="btn[this.btnIndex].dec"></div>
	        <div class="decEn" v-html="btn[this.btnIndex].decEn"></div>
	      </div>
	    </div>
	    
	  </div>
	</div>
  </div>
</template>

<script>
import { csvw_url } from "../../components/config";
import mixinMobile from "./mixinMobile";
import config from "./config4";
export default {
  mixins: [mixinMobile],
  components: {},
  data() {
    return {
      ...config,
      btnIndex: 0,
      activeNames: 0,
      activeNames1: 0,
      activeNames2: 0,
      activeNames3: 0,
    };
  },
};
</script>

<style lang="less" scoped>
@import url("./commonMobile.less");
// 主题颜色
@colorValue: #f9c213;
// 描述字体颜色
@fontValue: #666666;
// 板块背景色
@activeValue: #fef6dc;

.model-title.active {
  background: @colorValue;
}

.subtitle {
  color: @colorValue;
}

.flex-head,
.flex-model {
  background: @activeValue;
}
</style>
